
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import VirtualPOIDrawer from './components/VirtualPOIDrawer.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { AuthEnum } from '@/services/permission.service';
import VirtualPOIModal from './components/VirtualPOIModal.vue';

@Component({
  components: {
    VirtualPOIDrawer,
    VirtualPOIModal,
  },
  name: 'VirtualPOIList',
})
export default class VirtualPOIList extends Vue {
  @Ref('virtualPOIDrawer')
  virtualPOIDrawer: any;

  @Ref('virtualPOIModal')
  virtualPOIModal!: VirtualPOIModal;

  AuthEnum = AuthEnum;

  @lazyInject(ShopService)
  shopService!: ShopService;

  filterForm: any = {
    virtual_poi: '',
    company_name: '',
  };
  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };
  columns = [
    {
      title: '虚拟POI',
      dataIndex: 'virtual_poi',
      key: 'virtual_poi',
      align: 'center',
      scopedSlots: { customRender: 'virtual_poi' },
      width: 100,
    },
    {
      title: '高德POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      scopedSlots: { customRender: 'poi' },
      width: 100,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 100,
    },
    {
      title: '营业执照名称',
      dataIndex: 'company_name',
      key: 'company_name',
      align: 'center',
      width: 100,
    },
    {
      title: '营业执照信用代码',
      dataIndex: 'credit_code',
      key: 'credit_code',
      align: 'center',
      width: 100,
    },
    {
      title: '营业执照所在地',
      dataIndex: 'adname',
      key: 'adname',
      align: 'center',
      width: 100,
    },
    // {
    //   title: '创建时间',
    //   dataIndex: 'createTime',
    //   key: 'createTime',
    //   align: 'center',
    //   width: 100,
    // },
    {
      title: '创建人',
      dataIndex: 'create_user',
      key: 'create_user',
      align: 'center',
      width: 100,
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

  data = [];

  @Watch('$route')
  onRouteChange() {
    const { page, pageSize, virtual_poi, company_name } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || this.pagination.pageSize,
    };
    if (virtual_poi) {
      query.virtual_poi = virtual_poi;
    }
    if (company_name) {
      query.company_name = company_name;
    }
    this.postPoiList(query);
  }
  refresh() {
  }

  onChangePage(page: number) {
    console.log(page);
    this.pagination.current = page;
    this.getQuery();
  }

  onShowSizeChange(current: number, pageSize: number) {
    console.log(current, pageSize);
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }

  search() {
    this.pagination.current = 1;
    this.getQuery();
  }

  resetQuery() {
    this.pagination.current = 1;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
    };
    this.filterForm = {
      virtual_poi: '',
      company_name: '',
    };
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
  getQuery() {
    const { current, pageSize } = this.pagination;
    const { virtual_poi, company_name } = this.filterForm;
    const query: any = {
      page: current,
      pageSize,
    };
    if (virtual_poi) {
      query.virtual_poi = virtual_poi;
    }
    if (company_name) {
      query.company_name = company_name;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
  showDrawer() {
    this.virtualPOIDrawer.showDrawer();
  }


  async postPoiList(data: any) {
    const res = await this.shopService.postPoiList(data);
    if (res) {
      this.data = res.list;
      this.pagination.total = res.total;
      this.pagination.current = res.page;
    }
  }

  mounted() {
    this.onRouteChange();
  }
  async getData(val: any) {
    const params = {
      poi: val.virtual_poi,
    };
    const res = await this.shopService.postPoiUrl(params);
    if (res) {
      this.$copyText(String(res)).then(() => {
        this.$message.success('复制成功');
      }, (err) => {
        this.$message.error(`复制失败:${err}`);
      });
    }
  }

  changeName(val: any) {
    this.virtualPOIModal.init(val);
  }

  copyPOi(val: any) {
    this.$copyText(String(val)).then(() => {
      this.$message.success('复制成功');
    }, (err) => {
      this.$message.error(`复制失败:${err}`);
    });
  }
}
